/**
 * TanStack Query hooks for `clevertap-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	clevertapIntegrationQueryKeys,
	type CreateClevertapIntegrationBody,
	type CreateClevertapIntegrationResponse,
	type ListClevertapIntegrationResponse,
} from "./api";

export function useClevertapIntegrationList(): UseQueryResult<ListClevertapIntegrationResponse, Error> {
	return useQuery({
		queryKey: clevertapIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useClevertapIntegrationCreate(): UseMutationResult<
	CreateClevertapIntegrationResponse,
	Error,
	CreateClevertapIntegrationBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: clevertapIntegrationQueryKeys.all });
		},
	});
}
